import CrudCustom from '../../../libs/custom/CrudCustom';

let PPh25Service = new CrudCustom('/transaksi-pajak-terutang-pph-25s');
export default PPh25Service;
